/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RolesInputs */



/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Common_RolesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_roles = /** @type {((inputs?: Common_RolesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RolesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rôles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Roles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Funções")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ruoli")
	return /** @type {LocalizedString} */ ("Roles")
});